var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSetting({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4381 5.4175L14.2681 2.4275C13.2781 1.8575 11.7281 1.8575 10.7381 2.4275L5.51813 5.4375C3.44813 6.8375 3.32812 7.0475 3.32812 9.2775V14.7075C3.32812 16.9375 3.44813 17.1575 5.55813 18.5775L10.7281 21.5675C11.2281 21.8575 11.8681 21.9975 12.4981 21.9975C13.1281 21.9975 13.7681 21.8575 14.2581 21.5675L19.4781 18.5575C21.5481 17.1575 21.6681 16.9475 21.6681 14.7175V9.2775C21.6681 7.0475 21.5481 6.8375 19.4381 5.4175ZM12.4981 15.2475C10.7081 15.2475 9.24813 13.7875 9.24813 11.9975C9.24813 10.2075 10.7081 8.7475 12.4981 8.7475C14.2881 8.7475 15.7481 10.2075 15.7481 11.9975C15.7481 13.7875 14.2881 15.2475 12.4981 15.2475Z",
    fill: "#3498DB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSetting);
export default __webpack_public_path__ + "static/media/setting.0c048134e31e1302c07ed5eda604829a.svg";
export { ForwardRef as ReactComponent };